import {
  SET_SUCCESS,
  SET_CLOSE_SNACKBAR,
  SET_ERROR,
  SET_NOT_FOUND,
  SET_LOGOUT,
} from "actions"

export const initialState = {
  isOpen: false,
  variant: "",
  message: "",
}

export const snackbar = (state = initialState, action) => {
  let snackbar
  switch (action.type) {
    case SET_SUCCESS:
      snackbar = {
        isOpen: true,
        message: "Snackbar.Success",
        variant: "success",
      }
      return { ...state, ...snackbar }
    case SET_ERROR:
      snackbar = {
        isOpen: true,
        message: "Snackbar.Error",
        variant: "error",
      }
      return { ...state, ...snackbar }
    case SET_NOT_FOUND:
      snackbar = {
        isOpen: true,
        message: "Snackbar.NotFound",
        variant: "error",
      }
      return { ...state, ...snackbar }
    case SET_LOGOUT:
      snackbar = {
        isOpen: true,
        message: "Snackbar.Logout",
        variant: "success",
      }
      return { ...state, ...snackbar }
    case SET_CLOSE_SNACKBAR:
      snackbar = {
        isOpen: false,
        message: "",
      }
      return { ...state, ...snackbar }

    default:
      return state
  }
}
export default snackbar
